import React from 'react';
import { useDispatch } from 'react-redux';
import { actions as userActions } from 'store/user';
import { LoginComponent } from 'components';
const { sendForgotPassword } = userActions;

const schema = {
  answer: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};

const SecurityQuestionsAndReports = props => {
  const { user, handleBack } = props;
  const dispatch = useDispatch();
  const contactOptions = [
    {
      label: 'Email',
      value: 'USER_CONTACT_TYPE_EMAIL'
    },
    {
      label: 'SMS',
      value: 'USER_CONTACT_TYPE_SMS'
    }
  ];

  const handleNext = (event, values) => {
    event.preventDefault();
    let forgotData = user.forgotData;
    user.question.answer = values.answer;
    let option = { appTitle: 'rGuest', securityQuestion: [user.question] };
      let defaultOption = contactOptions.find(
        item => item.label === forgotData.notificationProvided
      );
      option.forgotPasswordRequest = {
        userContactType: defaultOption['value']
      };
    dispatch(sendForgotPassword(option));
  };

  const getInputFields = () => [
    { type: 'typography', label: user.question.securityQuestion },
    { name: 'answer', label: "Answer", type: 'text' },
    ...((user.forgotData.userEmailAndSMSProvided &&
      [{ name: 'userContactType', label: "Select a contact type", type: 'select', options: contactOptions }]) || [])
  ];

  const getButtonGroup = () => [
    { title: 'Submit', isSubmit: true, action: (event, values) => handleNext(event, values) },
    { title: 'Go to Sign in', action: handleBack, isEnabled: true }
  ];

  return (
    <LoginComponent
      title={'Security Question'}
      subTitle={'Give your answer'}
      inputFields={getInputFields()}
      buttonGroup={getButtonGroup()}
      schema={schema} />
  );
};

export default SecurityQuestionsAndReports;